import notification from './notification'

export function setAlertMessage(type, message, setNotiMsg = () => {}) {
  setNotiMsg({
    type: type,
    msg: message,
  })

  notification.open(type, {
    title: message,
    duration: 2500,
  })

  setTimeout(() => {
    setNotiMsg('')
  }, 2500)
}
